// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  appId: '202ab71ec7b28f0b80c9fd543fc794f5',
  units: 'metric',
  APIEndpoint: 'https://bosch-energyutilties-analytics.com',
  //'https://iep-test.southindia.cloudapp.azure.com',
  // APIEndpoint: 'http://sgpvmc0001.apac.bosch.com:8181',
  // APIEndpoint: 'http://localhost:8182',
  APISuffixes: 'iep',
  
  Version: 'v1',
  client_id: 'IEPEnergyWebClient',
  client_secret: '$2a$12$kUxzw1o/85lHoGnTIEpYoeb/55d4E.zHQUabm6NYqx97LzYFpI0V.',
  config: {
    tenantId: 'e01d2081-8764-4360-b95a-d4b7cdaca914',
    clientId: '40bcf5b1-f630-49ce-a7d9-066e6077aad1',
    redirectUri: 'https://bosch-energyutilties-analytics.com',
    cacheLocation: 'localStorage',
    endpoints: 'https://bosch-energyutilties-analytics.com'
    // popUp: true
  },
  // Check and force logout if user idle for X minutes.
  userIdleTimeInMinutes: 30
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
